import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages'
import { useTranslation } from '@/i18n'

// Lazy load pages for better performance
const Projects = lazy(() => import('./pages/Projects'))
const ProjectDetail = lazy(() => import('./pages/ProjectDetail'))
const About = lazy(() => import('./pages/About'))
const Game = lazy(() => import('./pages/Game'))

// Loading fallback component
function PageLoader() {
  const { t } = useTranslation()

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4 dark:border-blue-400"></div>
        <p className="text-gray-600 dark:text-gray-400">{t('common.loading')}</p>
      </div>
    </div>
  )
}

function App() {
  return (
    <Routes>
      {/* Gamer View - Standalone (no Layout) */}
      <Route
        path="game"
        element={
          <Suspense fallback={<PageLoader />}>
            <Game />
          </Suspense>
        }
      />

      {/* Portfolio Routes - With Layout */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route
          path="projects"
          element={
            <Suspense fallback={<PageLoader />}>
              <Projects />
            </Suspense>
          }
        />
        <Route
          path="projects/:id"
          element={
            <Suspense fallback={<PageLoader />}>
              <ProjectDetail />
            </Suspense>
          }
        />
        <Route
          path="about"
          element={
            <Suspense fallback={<PageLoader />}>
              <About />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
